module.exports = __webpack_public_path__ + "img/ExoticShorthair.a39b4872.svg";